import { decodeHtml } from "~/shared/utils";

import type { FileVariant } from "./types";

export const decodeFile = <T extends FileVariant>(f: T): T => ({
	...f,
	title: decodeHtml(f.title),
});
